import { render } from "./instructor-announcements.vue?vue&type=template&id=3986357b"
import script from "./instructor-announcements.vue?vue&type=script&lang=js"
export * from "./instructor-announcements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__